import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c6d2bd6a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c6d2bd6a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2bd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d2bd6a')) {
      api.createRecord('c6d2bd6a', component.options)
    } else {
      api.reload('c6d2bd6a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c6d2bd6a&scoped=true", function () {
      api.rerender('c6d2bd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/detail.vue"
export default component.exports